import { render } from "./dhBalance.vue?vue&type=template&id=97d2909c&scoped=true"
import script from "./dhBalance.vue?vue&type=script&lang=js"
export * from "./dhBalance.vue?vue&type=script&lang=js"

import "./dhBalance.vue?vue&type=style&index=0&id=97d2909c&scoped=scoped&lang=css"

import exportComponent from "/Users/leaf/Desktop/gmhwork/h5/zksq_H5/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-97d2909c"]])

export default __exports__